import { supabase } from '@/config/supabase';
import apiClient from '@/services/apiClient';

interface ProfileUpdateData {
    full_name?: string;
    avatar_url?: string;
    phone_number?: string;
    bio?: string;
    username?: string;
}

class ProfileHelper {
    private static instance: ProfileHelper;

    private constructor() { }

    public static getInstance(): ProfileHelper {
        if (!ProfileHelper.instance) {
            ProfileHelper.instance = new ProfileHelper();
        }
        return ProfileHelper.instance;
    }

    // Update profile using apiClient (authorization header handled automatically)
    // Converted to accept camelCase keys but mapping might be needed if backend expects specific format
    // But adhering to the User's pattern, passing data through. 
    // Wait, the User sent camelCase in ProfilePage.tsx. 
    // I should probably map it to snake_case if it's going to Supabase via backend, 
    // OR keep it as is if backend handles mapping.
    // I will keep the signature but use apiClient.

    async updateProfile(userId: string, data: any): Promise<any> {
        try {
            // The backend route is mounted at /api/profiles (plural)
            const response = await apiClient.put('/profiles', data);
            return response.data;
        } catch (error: any) {
            console.error('Error updating profile:', error);
            throw error;
        }
    }

    // Upload avatar using Supabase storage and then update profile URL
    async uploadAvatar(userId: string, file: File): Promise<string> {
        try {
            const fileExt = file.name.split('.').pop();
            const fileName = `${userId}-${Date.now()}.${fileExt}`;
            const filePath = `avatars/${fileName}`;

            const { error } = await supabase.storage
                .from('profiles')
                .upload(filePath, file, {
                    cacheControl: '3600',
                    upsert: true,
                });

            if (error) throw error;

            const { data: { publicUrl } } = supabase.storage
                .from('profiles')
                .getPublicUrl(filePath);

            // Update profile with new avatar URL using the API
            await this.updateProfile(userId, { avatarUrl: publicUrl });

            return publicUrl;
        } catch (error) {
            console.error('Error uploading avatar:', error);
            throw error;
        }
    }
}

export const profileHelper = ProfileHelper.getInstance();